module.exports = __webpack_public_path__ + "static/media/close-button.aeec2863.svg";